//Libs
import { Popover } from "antd";
import styled from "styled-components";

const PopoverStyled = styled(Popover)`
`;

export default PopoverStyled;
